import { titlePageInitialLabel } from '@/constants'
import { isAxiosError } from 'axios'
import { useEffect } from 'react'
import { isRouteErrorResponse, useLocation, useRouteError } from 'react-router'
import './RouterErrorHandler.scss'

const RouterErrorHandler = () => {
  const routeError = useRouteError()
  const location = useLocation()

  useEffect(() => {
    document.title = `${titlePageInitialLabel} - Error`
  }, [])

  console.error('routeError', routeError)
  // Function to extract error message
  const getErrorMessage = (error: unknown) => {
    // axios error
    if (isAxiosError(error)) {
      if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
        // access to parts of the error, like response
        console.log('Error axios response status:', error.response.status)
        console.log('Error axios response data:', error.response.data)
        return `${error.response.status}: ${error.response.data.error.message}`
      } else {
        // Something happened in setting up the request
        console.log('Error axios status', error.status)
        console.log('Error axios message', error.message)
        return `${error.status}: ${error.message}`
      }
    } else if (isRouteErrorResponse(error)) {
      // route error
      console.log('route error response status', error.status)
      console.log('route error response statusText', error.statusText)
      return `${error.status} ${error.statusText} ${error.data}`
    }
    console.log('unknown error')
    return `${routeError}`
  }

  return (
    <>
      <div className="error-container">
        <div className="error-content">
          <h1 className="error-title">Si sono verificati degli errori :(</h1>
          <h2 className="error-message">{getErrorMessage(routeError)}</h2>
          {location.key !== 'default' && (
            <p className="reload-text">
              Clicca{' '}
              <a href={location.pathname} className="reload-link">
                qui
              </a>{' '}
              per ricaricare la pagina
            </p>
          )}
        </div>
      </div>
    </>
  )
}

export default RouterErrorHandler
